import Model from 'src/models/model'
import { TYPES as SALES_CHANNEL_TYPES } from 'src/models/model/concerns/SalesChannelRestrictable'
import { isOutOfStock } from 'src/services/inventory/sales-restrictions'
import { toValue } from 'vue'

// Options is a hash containing fields that can be used to validate modifier availability.
const DEFAULT_OPTIONS = Object.freeze({
  salesChannel: null,
  orderItem: null
})

export function useIsModifierAvailable () {
  const currentSite = Model.configuration?.currentSite

  function isModifierAvailable (modifier, { salesChannel, orderItem } = DEFAULT_OPTIONS) {
    const modifierValue = toValue(modifier)

    if (_.isNil(modifierValue)) return false

    const salesChannelValue = toValue(salesChannel)
    const orderItemValue = toValue(orderItem)

    // The Modifier must be active (not archived) to be presented
    if (modifierValue.archivable && !modifierValue.isActive) return false

    // The Modifier must be available on the current Sales Channel
    if (!modifierValue.isSalesChannelEnabled(salesChannelValue)) return false

    // If the Sales Channel is private, the Modifier is available, regardless of
    // Inventory or Sales Toggle (the Modifier may be shown without being selectable)
    if (_.includes(SALES_CHANNEL_TYPES.PRIVATE, salesChannelValue)) return true

    if (modifierValue.salesDisabled) return false

    if (!_.isNil(orderItemValue?.itemOrderItem?.item) && currentSite?.activeInventoryStrategy?.excludeOutOfStockItemsForKioskAndConsumer) {
      if (isOutOfStock(modifierValue, { item: orderItemValue?.itemOrderItem?.item, itemOrderItem: orderItemValue?.itemOrderItem, orderItem: orderItemValue })) return false
    }

    return true
  }

  return {
    isModifierAvailable
  }
}
